var map = {
	"./LazyApportRetrait": [
		26836,
		836
	],
	"./LazyApportRetrait.tsx": [
		26836,
		836
	],
	"./LazyClotureCaisse": [
		61225,
		225
	],
	"./LazyClotureCaisse.tsx": [
		61225,
		225
	],
	"./LazyCreateArticle": [
		43965,
		965
	],
	"./LazyCreateArticle.tsx": [
		43965,
		965
	],
	"./LazyCreateClient": [
		5654,
		654
	],
	"./LazyCreateClient.tsx": [
		5654,
		654
	],
	"./LazyDefault": [
		94100,
		100
	],
	"./LazyDefault.tsx": [
		94100,
		100
	],
	"./LazyDemandeTransfert": [
		56962,
		962
	],
	"./LazyDemandeTransfert.tsx": [
		56962,
		962
	],
	"./LazyListTransfert": [
		60980,
		980
	],
	"./LazyListTransfert.tsx": [
		60980,
		980
	],
	"./LazyListTransfertCree": [
		92069,
		69
	],
	"./LazyListTransfertCree.tsx": [
		92069,
		69
	],
	"./LazyMenuForm": [
		90148,
		148
	],
	"./LazyMenuForm.tsx": [
		90148,
		148
	],
	"./LazyReduction": [
		19728,
		728
	],
	"./LazyReduction.tsx": [
		19728,
		728
	],
	"./LazyReservation": [
		21125,
		125
	],
	"./LazyReservation.tsx": [
		21125,
		125
	],
	"./LazyRestaurantTables": [
		21501,
		501
	],
	"./LazyRestaurantTables.tsx": [
		21501,
		501
	],
	"./LazyTransfertArticles": [
		49266,
		266
	],
	"./LazyTransfertArticles.tsx": [
		49266,
		266
	],
	"./LazyUpdatePin": [
		46060,
		60
	],
	"./LazyUpdatePin.tsx": [
		46060,
		60
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87651;
module.exports = webpackAsyncContext;